import { bindable, IEventAggregator, ILogger, resolve } from 'aurelia';

export class MealPlanPriceSelection {

    // properties for view component
    @bindable hotel;
    // generate unique id for html elements
    @bindable uniqueId;

    rooms = [];

    aurelia_options = aurelia_options;
    eventAggregator = resolve(IEventAggregator);
    log = resolve(ILogger).scopeTo('app.MealPlanPriceSelection');


    constructor() {
        this.eventId = null;
        this.filterMainDivId = null;

        // selectedMealTypeName - BB 
        // displayLabel - Bed&Breakfast
        this.selectedMealTypeName = "";
        this.displayLabel = "";

        this.selectedRoomType = null;
        this.allMealplans = [];
    }

    binding() {
        this.rooms = this.hotel.rooms;
        this.selectedRoomType = this.rooms[0];

        // set selected radio button to correct position
        // usually its 0, but its not quaranteed
        this.displayLabel = aurelia_options.translations.lmt_mealplans[this.selectedRoomType.mealplans[0].sort];
        this.selectedMealTypeName = this.selectedRoomType.mealplans[0].name;
        this.hotel.selected_mealplan_id = this.selectedRoomType.mealplans[0].id;

        this.allMealplans = Array.from(
            this.rooms
            .flatMap(r => r.mealplans)
            // remove duplicates by name
            .reduce((acc, item) => {
                acc.set(item.name, { name: item.name, sort: item.sort });
                return acc;
            }, new Map()).values()
        ).toSorted((a, b) => Number(a.sort) - Number(b.sort))
    }

    attached() {
        // generate eventAggregator eventId
        this.eventId = 'update-filter-' + this.uniqueId;
        this.filterMainDivId = 'e4-detailfilter-mealplan-' + this.uniqueId;
        
        this.updateFilterSubscription = this.eventAggregator.subscribe(this.eventId, params => this.updateFilterEvent(params));
    }

    detached() {
        this.updateFilterSubscription.dispose();
    }


    isMealplanDisabled(mealplan) {
        return this.selectedRoomType.mealplans.find(mp => mp.name === mealplan.name) === undefined;
    }

    calculateRoomPrice(mealplan) {
        // is there requested mealplan at all for current roomtype?
        if (this.isMealplanDisabled(mealplan)) {
            return 0;
        }
        let roomMealplan = this.rooms.find(room => room.id === this.hotel.selected_room_id).mealplans.find(mp => mp.name === mealplan.name);
        return roomMealplan.price - this.selectedRoomType.mealplans.find(mp => mp.name === this.selectedMealTypeName).price;
    }

    isSelectedElement(mealplan){
        return this.selectedMealTypeName == mealplan.name;
    }

    updateFilterEvent(params) {

        if (params.sender == 'room-type-selection') {
            this.selectedRoomType = params.room;
            // data was updated from roomtype selection - currently selected mealplan is possibly available in new room
            this.displayLabel = aurelia_options.translations.lmt_mealplans[params.mealplan.sort];
            this.selectedMealTypeName = params.mealplan.name;
            this.hotel.selected_mealplan_id = params.mealplan.id;
            
            // Tell Aurelia to update list items calls to calculateRoomPrice and isMealplanDisabled
            this.allMealplans = JSON.parse(JSON.stringify(this.allMealplans));
        }
    }

    //open-close filter details
    openCloseFilter() {
        this.setFilterVisible(! document.querySelector('#' + this.filterMainDivId).open);
    }

    setFilterVisible(show) {
        if (show) {
            document.querySelector('#' + this.filterMainDivId).show();
        } else {
            document.querySelector('#' + this.filterMainDivId).close();
        }
    }

    closeFilterWithDelay(mealplan) {
        // disabled variant was clicked - ignore and return immediately
        if (this.isMealplanDisabled(mealplan)) return;

        // new value was selected
        if (this.selectedMealTypeName != mealplan.name) {
            this.selectedMealTypeName = mealplan.name;
            let selectedMealplan = this.rooms.find(room => room.id === this.hotel.selected_room_id).mealplans.find(mp => mp.name === mealplan.name);
            this.hotel.selected_mealplan_id = selectedMealplan.id;
            // update visible mealplan description
            this.displayLabel = aurelia_options.translations.lmt_mealplans[selectedMealplan.sort];

            this.log.debug('mealplan: ', selectedMealplan);
            
            // broadcast change in mealplan selection
            this.eventAggregator.publish(this.eventId,
                {
                    sender: 'mealplan-selection',
                    room: this.selectedRoomType,
                    mealplan: selectedMealplan
                });
        }

        setTimeout(() => {
            this.setFilterVisible(false);

                // Tell Aurelia to update list items calls to calculateRoomPrice and isMealplanDisabled
            this.allMealplans = JSON.parse(JSON.stringify(this.allMealplans));
        }, 400);

        return true;
    }

}
